import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';

const DEVICE_IDENTIFIER = 'device_identifier';
const LOCATION = 'location';

export class FirebaseService {
    static async signInAnonymously() {
        await firebase.app().auth().signInAnonymously();
    }

    static instance() {
        return firebase;
    }
}

export const saveDeviceIdentifier = (identifier) => {
    localStorage.setItem(DEVICE_IDENTIFIER, identifier);
}

export const loadDeviceIdentifier = () => {
    return localStorage.getItem(DEVICE_IDENTIFIER);
}

export const clearDeviceIdentifier = () => {
    localStorage.removeItem(DEVICE_IDENTIFIER);
}

/**
 * The stored terminal identifier, plus whether the read actually succeeded.
 *
 * `logout()` clears the tokens and deliberately leaves the identifier alone, so
 * a value here means a session ended on a tablet that is already set up, rather
 * than somebody setting one up now.
 *
 * Reading localStorage can throw rather than return null (Safari private mode,
 * blocked site data), and the two outcomes are not the same fact: "this tablet
 * has never registered" is knowledge, "the identifier could not be read" is the
 * absence of it. Callers that only choose a reassuring sentence can collapse
 * them - see `readStoredIdentifier` - but a caller that tells someone what to DO
 * cannot, because the instruction differs.
 */
export const readStoredIdentity = () => {
    try {
        return {available: true, identifier: loadDeviceIdentifier()};
    } catch (e) {
        return {available: false, identifier: null};
    }
}

/**
 * The stored terminal identifier, or null if this tablet has never registered
 * *or* the read failed.
 *
 * The collapse is deliberate and safe here: every caller uses this to decide
 * whether to add a reassuring sentence, and omitting that sentence is the right
 * behaviour when the fact cannot be established. Anything that instructs the
 * reader should use `readStoredIdentity` instead.
 */
export const readStoredIdentifier = () => readStoredIdentity().identifier;

export const saveLocation = (location) => {
    localStorage.setItem(LOCATION, location);
}

export const loadLocation = () => {
    return localStorage.getItem(LOCATION);
}

export const clearLocation = () => {
    localStorage.removeItem(LOCATION);
}
